<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="350">
      <template v-slot:activator="{ on }">
        <v-btn block :loading="dialog" color="success" v-on="on"
          >Withdraw (OUT)</v-btn
        >
      </template>
      <v-card>
        <v-card-title class="warning headline">Withdraw Form</v-card-title>
        <v-card-text>
          <v-form ref="withDrowform" v-model="valid">
            <!-- <p
              class="font-weight-black text-center black--text"
              v-if="withdrow.amount"
            >
              {{ withdrow.amountType | MoneySigns }}
              {{ withdrow.amount.toLocaleString() }}
            </p> -->

            <!-- <v-text-field
              autofocus
              v-model.number.trim="withdrow.amount"
              :rules="[v => !!v || 'Amount is required']"
              name="withdrowAmount"
              label="Withdrow Amount"
              type="number"
              prepend-icon="mdi-cash-multiple"
            ></v-text-field> -->

            <BaseNumInput
              class="mt-3"
              autofocus
              outlined
              dense
              :rules="[v => !!v || 'Amount is required']"
              append-icon="mdi-cash-multiple"
              :prefix="withdrow.amountType | MoneySigns"
              v-model.trim="withdrow.amount"
              label="Withdrow Amount"
            ></BaseNumInput>

            <div v-show="withdrow.amount > 0">
              <v-select
                outlined
                dense
                append-icon="mdi-cash"
                v-model.trim="withdrow.amountType"
                :items="GetCashTypes"
                :rules="[v => !!v || 'Cash Type is required']"
                label="Cash Type"
                required
              ></v-select>

              <v-text-field
                outlined
                dense
                v-model="withdrow.date"
                :rules="[v => !!v || 'Withdrow Date is required']"
                required
                name="withdrowFild"
                label="Withdrow Date"
                type="date"
              ></v-text-field>

              <v-textarea
                outlined
                v-model="withdrow.details"
                :rules="[v => !!v || 'Details is required']"
                append-icon="mdi-android-messages"
                label="Details"
                clearable
                counter="100"
                auto-grow
                row-height="2"
              ></v-textarea>
            </div>
          </v-form>
          <p class="text-center mt-2 red--text">{{ ErrorMsg }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="clicked" color="green darken-1" text @click="close"
            >Cancel</v-btn
          >
          <v-btn
            :disabled="!valid"
            :loading="clicked"
            color="green darken-1"
            text
            @click="OnDeposit"
            >Withdraw</v-btn
          >
        </v-card-actions>

        <!-- <p>{{ AccountNumber }}</p> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: { AccountNumber: [Number], FinishedWithdrow: [Function] },
  data() {
    return {
      valid: true,
      dialog: false,
      ErrorMsg: "",
      clicked: false,
      withdrow: {
        amount: null,
        amountType: null,
        AccountNumber: "",
        details: "",
      },
    };
  },
  computed: {
    ...mapGetters(["GetCashTypes"]),
  },
  methods: {
    close() {
      this.dialog = false;
      this.$refs.withDrowform.reset();
      this.withdrow.date = this.Current().date;
    },
    OnDeposit() {
      this.ErrorMsg = "";
      if (this.$refs.withDrowform.validate()) {
        this.clicked = true;
        this.withdrow.time = this.Current().time;
        this.withdrow.AccountNumber = this.AccountNumber;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/qarash/withdraw",
            data: this.withdrow,
          })
          .then(result => {
            this.clicked = false;
            this.close();
            // console.log(result);
            this.FinishedWithdrow(result.data);
          })
          .catch(err => {
            this.clicked = false;
            // console.log(err.response);
            if (err.response.status === 400) this.ErrorMsg = err.response.data;
          });
      }
    },
  },
  mounted() {
    this.withdrow.date = this.Current().date;
  },
};
</script>
